// src/sweetalert.js
import Vue from "vue";
import Swal from "@sweetalert2/theme-bootstrap-4";

Vue.prototype.$swal = Swal;
